var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-body"},[_c('Button',{attrs:{"type":"info"}},[_vm._v("添加")])],1),_vm._v(" "),_c('Divider'),_vm._v(" "),_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.data,"border":""}}),_vm._v(" "),_c('div',{staticClass:"page-body"},[_c('Page',{attrs:{"total":_vm.total,"current":_vm.page,"show-elevator":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5639deb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/child/Html.vue
// module id = null
// module chunks = 